import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { showLuckyPopupAction } from './store/actions';

export const useLuckyPopup = (uniqueGames) => {
    const dispatch = useDispatch();

    return useCallback(
        popupData => dispatch(showLuckyPopupAction(popupData, uniqueGames)),
        [dispatch, uniqueGames]
    );
};
